import useUserQuery from "../components/Common/useUserQuery";
import { QueryOptions } from "../components/Common/useQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { OptionalAmount } from "../components/Common/dtos/OptionalAmount";

export interface TransportHistoryReportDto {
  transportName: string;
  compartmentIndex?: number;
  ticketNumber: string;
  orderNumber?: string;
  loadedAt: string;
  customerName?: string;
  destination?: string;
  notes?: string;
  productMeasurements: { [productName: string]: OptionalAmount };
}

export interface TransportHistoryReportParams {
  units?: string;
  transportId?: string;
  siteId?: string;
  startDate?: string;
  endDate?: string;
}

const useGetTransportHistoryReport = (
  params: TransportHistoryReportParams,
  options?: QueryOptions<TransportHistoryReportDto[]>
) => {
  const business = useSelectedBusiness();

  return useUserQuery<TransportHistoryReportDto[]>({
    path: formatTransportHistoryReportQuery(business.id, params),
  }, {
    autoQuery: false,
    ...options
  });
}

export const formatTransportHistoryReportQuery = (businessId: string, params: TransportHistoryReportParams) => {
  const urlParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      urlParams.append(key, value.toString());
    }
  });

  return `/api/businesses/${businessId}/reports/transportHistory?${urlParams.toString()}`;
}

export default useGetTransportHistoryReport;
